import { render, staticRenderFns } from "./AppAvatar.vue?vue&type=template&id=64067591"
import script from "./AppAvatar.vue?vue&type=script&lang=ts"
export * from "./AppAvatar.vue?vue&type=script&lang=ts"
import style0 from "./AppAvatar.vue?vue&type=style&index=0&id=64067591&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports